import React, { useImperativeHandle, forwardRef, useState } from 'react';
import { useRefresh } from 'react-admin';

import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useSnackbar } from 'notistack';

import { TextInput } from '../../../Components';
import { api, getListAllAPI, getUserId } from '../../../services';
import { formatCNPJ, formatDateDDMMYYYY, formatMoeda } from '../../../utils';

const FormDialog = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(-1);
  const [dados, setDados] = useState({
    nsu: '',
    emitRazao: '',
    emitCnpj: '',
    chave: '',
    dhEmis: '',
    vNF: '',
  });
  const refresh = useRefresh();
  const { enqueueSnackbar } = useSnackbar();
  const [descricaoProblema, setDescricaoProblema] = useState('');

  const handleClose = () => {
    setOpen(false);
  };

  async function handleConfirma() {
    try {
      const response = await api.put(
        `/nfe_compras/marcar_como_recebida/${id}`,
        {
          descricao_problema: descricaoProblema,
          recebedor_user_id: getUserId(),
        },
      );
      const { status, message } = response.data;

      if (status) {
        enqueueSnackbar('Sucesso ao MARCAR A NFe de compra como RECEBIDA!', {
          variant: 'success',
        });
      } else {
        enqueueSnackbar(`${message}`, {
          variant: 'error',
        });
      }

      refresh();
      setOpen(false);
      setDescricaoProblema('');
      setDados({
        nsu: '',
        emitRazao: '',
        emitCnpj: '',
        chave: '',
        dhEmis: '',
        vNF: '',
      });
    } catch (erros) {
      setOpen(false);
      setDescricaoProblema('');
      setDados({
        nsu: '',
        emitRazao: '',
        emitCnpj: '',
        chave: '',
        dhEmis: '',
        vNF: '',
      });
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
    }
  }

  async function getDados(id) {
    try {
      const data = await getListAllAPI(
        'nfe_compras',
        ['id', 'asc'],
        { id: [id] },
        [],
      );

      if (data.data.length <= 0) {
        throw 'Esta NFe de Compra não existe!';
      }

      setDados(dadosFormatados(data.data[0]));
    } catch (erros) {
      setOpen(false);
      setDados({
        nsu: '',
        emitRazao: '',
        emitCnpj: '',
        chave: '',
        dhEmis: '',
        vNF: '',
      });
      setDescricaoProblema('');
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      setOpen(true);
      setId(id);
      getDados(id);
    },
  }));

  function dadosFormatados(dados) {
    return {
      nsu: dados.nsu,
      emitRazao: dados.emitRazao,
      emitCnpj: formatCNPJ(dados.emitCnpj),
      chave: dados.chave,
      dhEmis: formatDateDDMMYYYY(dados.dhEmis),
      vNF: formatMoeda(dados.vNF),
    };
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          id="form-dialog-title"
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          Marcar esta NFe como RECEBIDA
        </DialogTitle>
        <DialogContent dividers>
          <div>
            <h3>Tem certeza que deseja marcar esta NFe como RECEBIDA!</h3>

            <div
              style={{
                marginTop: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '5px',
                marginBottom: '20px',
              }}
            >
              <div>
                <span style={{ fontWeight: 'bold' }}>NSU: </span>
                {`${dados.nsu}`}
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>
                  Razão Social do Emitente:{' '}
                </span>
                {`${dados.emitRazao}`}
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>CNPJ do Emitente: </span>
                {`${dados.emitCnpj}`}
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>Data da Emissão: </span>
                {`${dados.dhEmis}`}
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>Valor da NFE: </span>
                {`${dados.vNF}`}
              </div>
              <div>
                <span style={{ fontWeight: 'bold' }}>Chave de Acesso: </span>
                {`${dados.chave}`}
              </div>
            </div>
          </div>
          <TextInput
            label="Descrição do Problema"
            multiline
            rows={4}
            name="descricao_problema"
            handleEnter={() => {}}
            handleKey={() => {}}
            value={descricaoProblema}
            onChange={(value) => setDescricaoProblema(value.target.value)}
            /* error={erros[10] !== ''}
            helperText={erros[10]} */
            fullWidth
          />
        </DialogContent>
        <DialogActions
          style={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'space-between',
          }}
        >
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>
          <Button onClick={handleConfirma} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default FormDialog;
